export default __webpack_public_path__ + "static/media/body-section-abdomen.d3dd2158.png";